import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { ANGELICA_LUGO_ANCHOR_SRC, YELITZA_YANEZ_ANCHOR_SRC } from '../brandAssets';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          Después del evento: historias humanas que permanecen
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          Donde el periodismo de soluciones encuentra la resiliencia: entrevistas profundas que trascienden la noticia para explorar cómo el trauma se transforma en superación.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es Después del evento?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/despuesdelevento"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/despuesdelevento
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Con <strong>Angélica Lugo</strong> y <strong>Yelitza «Yeyé» Yánez</strong>: conversación íntima con figuras públicas y ciudadanos que prevalecen.{' '}
          <strong>Martes 7:00 PM</strong> (Venezuela) en vivo, On-Demand y redes del ecosistema TNO Network.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Typography
          variant={'h5'}
          fontWeight={700}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
          sx={{ mb: 3 }}
        >
          NUESTRAS ANCLAS: ANGÉLICA LUGO Y YELITZA YÁNEZ
        </Typography>
        <Grid container spacing={4} alignItems="flex-start">
          <Grid item xs={12} md={6}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Box
                component="img"
                src={ANGELICA_LUGO_ANCHOR_SRC}
                alt="Angélica Lugo - Después del evento"
                sx={{
                  width: { xs: 200, sm: 240 },
                  height: { xs: 200, sm: 240 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                  mb: 2,
                }}
              />
              <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
                Angélica Lugo
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                Periodista y comunicadora; voz de credibilidad en análisis, entrevistas y narrativa de impacto en TNO Network.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Box
                component="img"
                src={YELITZA_YANEZ_ANCHOR_SRC}
                alt="Yelitza Yánez (Yeyé) - Después del evento"
                sx={{
                  width: { xs: 200, sm: 240 },
                  height: { xs: 200, sm: 240 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                  mb: 2,
                }}
              />
              <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
                Yelitza Yánez (Yeyé)
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                Periodista y creadora de contenido; conexión humana y cercanía para historias que inspiran y sanan.
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Typography variant="body1" color="textSecondary" align="center" sx={{ mt: 4, maxWidth: 800, mx: 'auto' }}>
          Juntas conducen un espacio donde marcas de bienestar, salud mental, educación, ONG y servicios con propósito encuentran una audiencia que valora la verdad emocional y el periodismo de soluciones.
        </Typography>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
